// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectBar {
  text-align: inherit;
  background: violet;
  padding: 10px;
  z-index: 1000;
}

.footit {
  position: fixed;
  width: 100%;
  z-index: 99999;
  bottom: 0px;
}

.board {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
}

.card-list {
  height: 100%;
  width: 320px;
  overflow: auto;
  box-sizing: border-box;
  margin-right: 8px;
  flex-shrink: 0;
  overscroll-behavior: contain;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 8px;
}

.card-list {
  display: flex;
  flex-direction: column;
}
.card-list h2 {
  margin-bottom: 5px;
}
.card-list button {
  flex-shrink: 0;
  margin-top: 10px;
}

.card-list-content {
  overflow: auto;
  overscroll-behavior: contain;
  flex-grow: 1;
}

.cdk-drag-animating, .cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.transitionFromHeight {
  position: sticky;
  bottom: 0px;
  width: 100%;
  z-index: 111;
  overflow-y: scroll;
  overscroll-behavior: contain;
  transition: height 0.5s ease-in-out;
}

.onBottomPopup {
  position: sticky;
  bottom: 0px;
  width: 100%;
  z-index: 999137;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/select-bar/select-bar.component.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EAEA,kBAAA;EACA,aAAA;EAGA,aAAA;AAHF;;AAMA;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;AAHF;;AAYA;EAGE,aAAA;EACA,mBAAA;EAGA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EAGA,gBAAA;EACA,kBAAA;AAfF;;AAkBA;EAEE,YAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EAGA,+BAAA;EACA,kBAAA;EACA,YAAA;AAlBF;;AAqBA;EAEE,aAAA;EACA,sBAAA;AAnBF;AAqBE;EAEE,kBAAA;AApBJ;AAuBE;EAEE,cAAA;EACA,gBAAA;AAtBJ;;AA0BA;EAEE,cAAA;EACA,4BAAA;EACA,YAAA;AAxBF;;AA8BA;EACE,sDAAA;AA3BF;;AA+BA;EACE,UAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EAKA,mCAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AA5BF","sourcesContent":["\n.selectBar {\n  text-align: inherit;\n  //position: absolute;\n  background: violet;\n  padding: 10px;\n  //width: 301px;\n  //max-width: 300px;\n  z-index: 1000;\n}\n\n.footit {\n  position: fixed;\n  width: 100%;\n  z-index: 099999;\n  bottom: 0px;\n}\n\n//depricated to global.css bigger-popover\n.selectBarBigger {\n  //width: 501px;\n  //max-width: 500px;\n}\n\n.board {\n  // Flexbox styling that defines the direction in which the content is flowing.\n  // Also makes it easier to stretch the lists to the height of the screen later on.\n  display: flex;\n  flex-direction: row;\n\n  // Ensure that the board covers the viewport and add some padding to make it look better.\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n\n  // Only allow horizontal scrolling.\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.card-list {\n  // Stretch the element to the height of the board and make it scrollable.\n  height: 100%;\n  width: 320px;\n  overflow: auto;\n  box-sizing: border-box;\n  margin-right: 8px;\n  flex-shrink: 0;\n  overscroll-behavior: contain;\n\n  // Some extra styling to make the card list look better.\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 4px;\n  padding: 8px;\n}\n\n.card-list {\n  // Makes it possible for the `card-list-content ` to take up the remaining space.\n  display: flex;\n  flex-direction: column;\n\n  h2 {\n    // Extra spacing to make things look better.\n    margin-bottom: 5px;\n  }\n\n  button {\n    // The flex-shrink prevents the button from shrinking if the list content becomes too large.\n    flex-shrink: 0;\n    margin-top: 10px;\n  }\n}\n\n.card-list-content {\n  // Make the list scrollable and stretch it to take up the available height.\n  overflow: auto;\n  overscroll-behavior: contain;\n  flex-grow: 1;\n}\n\n// If items are being reordered through dragging, all other elements should\n// reorder smoothly. Also if an item is being dropped, it should animate\n// into its target position.\n.cdk-drag-animating, .cdk-drop-list-dragging .cdk-drag {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n// Hides the placeholder if an element is being dragged.\n.cdk-drag-placeholder {\n  opacity: 0;\n}\n\n.transitionFromHeight {\n  position: sticky;\n  bottom: 0px;\n  width: 100%;\n  z-index: 111;\n  overflow-y: scroll;\n  overscroll-behavior: contain;\n  -webkit-transition: height 0.5s ease-in-out;\n  -moz-transition: height 0.5s ease-in-out;\n  -ms-transition: height 0.5s ease-in-out;\n  -o-transition: height 0.5s ease-in-out;\n  transition: height 0.5s ease-in-out;\n}\n\n.onBottomPopup {\n  position: sticky;\n  bottom: 0px;\n  width: 100%;\n  z-index: 999137;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
